module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-email-driver",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n        Email Load Details\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body m-t-sm"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('to')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.to),
      expression: "email.to"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "to",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.email.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email.to = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CC")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.cc),
      expression: "email.cc"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "CC"
    },
    domProps: {
      "value": (_vm.email.cc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email.cc = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('subject')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Subject")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email.subject),
      expression: "email.subject"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "subject",
      "placeholder": "Subject",
      "value": ""
    },
    domProps: {
      "value": (_vm.email.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email.subject = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('quill', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "placeholder": "Write a message...",
      "height": 300,
      "name": "message"
    },
    model: {
      value: (_vm.email.message),
      callback: function($$v) {
        _vm.email.message = $$v
      },
      expression: "email.message"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('ladda-button', {
    attrs: {
      "on-click": _vm.handleSendEmail,
      "type": "success",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Send")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7c962f96"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/EmailModal.vue
// module id = 1055
// module chunks = 0